export enum PromoType {
    Percentage = 0,
    FixedAmount = 1
}

export interface PromoCode {
    id: number;
    code: string;
    description: string;
    type: number;
    value: number;
    usageLimit: number;
    usageCount: number;
    validityFrom: string;
    validityTo: string;
    isActive: boolean;
    status?: string;
}
